// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"514":"482d9c7d0c9e0b47","977":"884e1b08398bb6e3"}[chunkId] + ".js";
};